function Contact() {
    return (
        <div class="app-development About-us_Wrapper Contact-Us_Wrapper wow fadeIn" style={{ marginTop: "5.2%" }}>
            <section class="banner_wrapper wow fadeIn" style={{ visibility: "visible" }}>
                {/* <!-- id="module" --> */}
                <div id="element2"> </div>
                <div class="container">
                    <div class="Banner_content">
                        <div class="Bnr_left bnr-cmn">
                            <div class="hero_text">
                                <h1 data-aos="zoom-in"
                                    data-aos-duration="300"
                                    data-aos-easing="ease-in-sine">Contact Us</h1>
                            </div>
                            {/* <!-- cd-intro --> */}
                            <p data-aos="fade-up"
                                data-aos-duration="450"
                                data-aos-easing="ease-in-sine">
                            </p>
                        </div>
                    </div>
                </div>

            </section>
            <section class="Our-Service_wrapper UIContent_Wrp AppConten_wrp Android_wrp wow fadeIn Contact_wrp" style={{ visibility: "visible" }}>
                <div class="container">
                    <div class="Srv-heading">
                        <h2 data-aos="zoom-in"
                            data-aos-duration="10"
                            data-aos-easing="ease-in-sine">Get in Touch</h2>
                        <p data-aos="fade-up"
                            data-aos-duration="10"
                            data-aos-easing="ease-in-sine">Do you have any queries? We would love to hear from you. Whether you want to talk to us about any of our services, or you would like to know us better, get in touch today!
                        </p>
                    </div>
                    <div class="contact-form_wrapper">
                        <div class="left_side01 Contact_cmn01">
                            <div id="map-canvas" data-aos="zoom-in"
                                data-aos-duration="400"
                                data-aos-easing="ease-in-sine">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d56100.367244625886!2d77.05120526328555!3d28.501434441689433!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m5!1s0x390d19152ecb21c1%3A0x808292ec66a4945e!2sMassman%20CyberGeeks%20-%20Digital%20Marketing%20Company%20in%20Gurgaon%2C%20Udyog%20Vihar%20Phase%20V%2C%20Phase%20V%2C%20Udyog%20Vihar%2C%20Sector%2019%2C%20Gurugram%2C%20Haryana!3m2!1d28.5013635!2d77.0862247!4m0!5e0!3m2!1sen!2sin!4v1611295005843!5m2!1sen!2sin" width="100%" height="100%" frameborder="0" style={{ border: 0 }} allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                            </div>
                        </div>
                        <div class="right-side01 Contact_cmn01">
                            {/* <!-- <div class="L01 Rfm_cmn">
                                <blockquote>
                                    <ul>
                                        <li data-aos="fade-up"
                                            data-aos-duration="700"
                                            data-aos-easing="ease-in-sine">
                                            <p><i class="fa fa-map-marker" aria-hidden="true"></i>Tech DH - 312, Shivalik, Dabholi Road, Surat 395004 </p>
                                        </li>
                                        <li data-aos="fade-up"
                                            data-aos-duration="600"
                                            data-aos-easing="ease-in-sine">
                                            <p> <i class="fas fa-phone-alt"></i><b>Phone : </b>07069201684</p>
                                        </li>
                                        <li data-aos="fade-up"
                                            data-aos-duration="600"
                                            data-aos-easing="ease-in-sine">
                                            <p><i class="far fa-envelope"></i><b>Email : </b>devotedhorses@gmail.com</p>
                                        </li>
                                    </ul>
                                </blockquote>

                            </div> --> */}
                            <div class="container" >
                                <div class="Service_content" style={{ padding: 0 }}>
                                    <div class="a1 Srv_cmn" data-tilt data-tilt-reverse="true" data-aos="fade-up"
                                        data-aos-duration="700"
                                        data-aos-easing="ease-in-sine">
                                        <figure>
                                            <span class="spn1"> <img src="image/phone.svg" alt="img" /></span>
                                        </figure>
                                        <figcaption>
                                            <h2 style={{ fontSize: "1em" }}>
                                                +91 7069201684
                                            </h2>
                                            {/* <!-- <p>Our significant knowledge of mobile application development technologies & frameworks,…</p> --> */}
                                        </figcaption>
                                    </div>
                                    <div class="a2 Srv_cmn" data-tilt data-tilt-reverse="true" data-aos="fade-up"
                                        data-aos-duration="700"
                                        data-aos-easing="ease-in-sine">
                                        <figure>
                                            <span class="spn1">   <img src="image/location.svg" alt="img" /></span>
                                        </figure>
                                        <figcaption>
                                            <h2 style={{ fontSize: "1em" }}>
                                                Tech DH - 312, Shivalik, Dabholi Road, Surat 395004
                                            </h2>
                                            {/* <!-- <p>Our significant knowledge of mobile application development technologies & frameworks,…</p> --> */}
                                        </figcaption>
                                    </div>
                                    <div class="a3 Srv_cmn" id="Scroll_bottm" data-tilt data-tilt-reverse="true" data-aos="fade-up"
                                        data-aos-duration="700"
                                        data-aos-easing="ease-in-sine">
                                        <figure>
                                            <span class="spn1">   <img src="image/email.svg" alt="img" /></span>
                                        </figure>
                                        <figcaption>
                                            <h2 style={{ fontSize: "1em" }}>
                                                devotedhorses@gmail.com
                                            </h2>
                                            {/* <!-- <p>Our significant knowledge of mobile application development technologies & frameworks,…</p> --> */}
                                        </figcaption>
                                    </div>
                                </div>
                            </div>
                            <div class="form_wrp Rfm_cmn" data-aos="fade-up"
                                data-aos-duration="350"
                                data-aos-easing="ease-in-sine">
                                <div class="form_heading">
                                    <h2 data-aos="fade-up"
                                        data-aos-duration="400"
                                        data-aos-easing="ease-in-sine">Send Us a Message</h2>
                                    {/* <!-- <p data-aos="fade-up"
                                        data-aos-duration="700"
                                        data-aos-easing="ease-in-sine">Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga, atque.</p> --> */}
                                </div>
                                <form action="#" method="" data-aos="fade-up"
                                    data-aos-duration="600"
                                    data-aos-easing="ease-in-sine">
                                    <div class="f1 Cont_Cmn2" >
                                        {/* <!-- <label for="#">  Name<sup>*</sup> </label> --> */}
                                        <input type="text" name="Name01" id="Name01" placeholder="Your Full Name" required />
                                    </div>
                                    <div class="f2 Cont_Cmn2" >
                                        {/* <!-- <label for="#">  E-mail<sup>*</sup>  </label> --> */}
                                        <input type="email" name="Email01" id="Email01" placeholder="Enter your E-mail" required />
                                    </div>
                                    <div class="f3 Cont_Cmn2" >
                                        {/* <!-- <label for="#"> Number <sup>*</sup></label> --> */}
                                        <input type="Number" name="Number01" id="Number01" placeholder="Enter your Phone Number" required />
                                    </div>
                                    <div class="f4 Cont_Cmn2" >
                                        {/* <!-- <label for="#">Subject<sup>*</sup> </label> --> */}
                                        <textarea title="type your subject" name="textarea1" id="textarea01" cols="30" rows="10" placeholder="Tell Us about your project"></textarea>
                                    </div>
                                    <div class="f5 Cont_Cmn2" >
                                        <label for="#">
                                            <input type="submit" value="Submit" id="input02" />
                                        </label>
                                    </div>


                                </form>
                            </div>
                        </div>
                    </div>
                </div >
            </section >


        </div >
    )
}

export default Contact